export const NO_TIME_LIMIT_TEXT = `без срока`;

export const KeyboardKeys = {
  ESCAPE: `Escape`,
  ENTER: `Enter`,
  SPACE: `Space`,
  ARROW_DOWN: `ArrowDown`,
  ARROW_UP: `ArrowUp`,
  ARROW_RIGHT: `ArrowRight`,
  ARROW_LEFT: `ArrowLeft`,
};

export const VisibleStatus: Record<string, `SHOW` | `HIDE`> = {
  SHOW: `SHOW`,
  HIDE: `HIDE`,
};

export const SearchInputStatus = {
  ACTIVATE: `ACTIVATE`,
  DISABLED: `DISABLED`,
};

export const ActivityType = {
  SHOW: `SHOW`,
  HIDE: `HIDE`,
};

export const ListActions = {
  SHOW: `SHOW`,
  HIDE: `HIDE`,
};

export const AddCartTypes = {
  PLUS: `PLUS`,
  MINUS: `MINUS`,
};

export const priorityColorClass = {
  1: `priority__block--priority-1`,
  2: `priority__block--priority-2`,
  3: `priority__block--priority-3`,
  4: `priority__block--priority-4`,
  5: `priority__block--priority-5`,
  6: `priority__block--priority-6`,
  7: `priority__block--priority-7`,
  8: `priority__block--priority-8`,
  9: `priority__block--priority-9`,
  10: `priority__block--priority-10`,
};

export const priorityClasses = [
  `priority__block--priority-1`,
  `priority__block--priority-2`,
  `priority__block--priority-3`,
  `priority__block--priority-4`,
  `priority__block--priority-5`,
  `priority__block--priority-6`,
  `priority__block--priority-7`,
  `priority__block--priority-8`,
  `priority__block--priority-9`,
  `priority__block--priority-10`,
];

export const categoryColorClass = {
  active: `create__sort-button--active`,
  archive: `create__sort-button--archive`,
};

export const categoryClasses = [`create__sort-button--active`, `create__sort-button--archive`];

export const RESET_INPUT_VALUE = ``;

export const WeekDay = {
  0: `вс`,
  1: `пн`,
  2: `вт`,
  3: `ср`,
  4: `чт`,
  5: `пт`,
  6: `сб`,
};
